<form class="one-col" [formGroup]="Form">
  <h4 class="text-center vs-text-blue mb-4">
    {{data && data['id'] ? 'Edición ' : 'Creación '}} de {{data['modal'].item}}
  </h4>
  <ng-template [ngIf]="data['modal'].type === 1">
    <mat-form-field appearance="outline">
      <mat-label>Asegurado</mat-label>
      <input formControlName="security" matInput autocomplete="off" placeholder="Ingresar Asegurado..." type="text">
    </mat-form-field>
    <mat-form-field appearance="outline">
      <mat-label>Beneficiario</mat-label>
      <input formControlName="benefits" matInput autocomplete="off" placeholder="Ingresar beneficiario..." type="text">
    </mat-form-field>
    <mat-form-field appearance="outline">
      <mat-label>Entidad</mat-label>
      <input formControlName="entity" matInput autocomplete="off" placeholder="Ingresar entidad..." type="text">
    </mat-form-field>
    <ng-template [ngIf]="showOrder">
      <mat-form-field appearance="outline">
        <mat-label>Orden</mat-label>
        <input formControlName="orderId" matInput autocomplete="off" placeholder="Ingresar orden..." type="number">
        <mat-hint align="end">Ejemplo: 1,2,3...</mat-hint>
      </mat-form-field>
    </ng-template>
  </ng-template>
  <ng-template [ngIf]="data['modal'].type === 2">
    <div class="row">
      <div class="col-6 " *ngIf="yearReclaim < 2024">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Operación</mat-label>
          <input formControlName="operation" matInput autocomplete="off" placeholder="Ingresar operación..."
                 type="text">
        </mat-form-field>
      </div>
      <div class="col-6 " *ngIf="yearReclaim >= 2024">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Producto</mat-label>
          <input formControlName="product" matInput autocomplete="off" placeholder="Ingresar producto..."
            type="text">
        </mat-form-field>
      </div>
      <div class="col-6">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Reclamo</mat-label>
          <input formControlName="request" matInput autocomplete="off" placeholder="Ingresar reclamo..." type="text">
        </mat-form-field>
      </div>
    </div>
    <mat-divider class="my-3"></mat-divider>
    <div class="row">
      <div class="col-6 " *ngIf="yearReclaim < 2024">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Reclamos en progreso</mat-label>
          <input formControlName="progresive" matInput autocomplete="off"
                 placeholder="Ingresar reclamos en progreso..."
                 type="number">
        </mat-form-field>
      </div>
      <div class="col-6 " *ngIf="yearReclaim >= 2024">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Submotivo</mat-label>
          <input formControlName="subReason" matInput autocomplete="off" placeholder="Ingresar submotivo..." type="text">
        </mat-form-field>
      </div>      
      <div class="col-6">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Absuelto a favor de empresa</mat-label>
          <input formControlName="company" matInput autocomplete="off" placeholder="Ingresar absueltos..."
                 type="number">
        </mat-form-field>
      </div>
      <div class="col-6">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Absuelto a favor del usuario</mat-label>
          <input formControlName="client" matInput autocomplete="off" placeholder="Ingresar absueltos..."
                 type="number">
        </mat-form-field>
      </div>
      <div class="col-6">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Total reclamos</mat-label>
          <input formControlName="total" matInput autocomplete="off" placeholder="Ingresar total..." type="number">
        </mat-form-field>
      </div>



      <div class="col-6">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Tiempo promedio</mat-label>
          <input formControlName="days" matInput autocomplete="off" placeholder="Ingresar tiempo..." type="number">
        </mat-form-field>
      </div>
    </div>
    <ng-template [ngIf]="showDate">
      <mat-form-field appearance="outline">
        <mat-label>Fecha de registro</mat-label>
        <input id="pickerDateRegister" matInput [matDatepicker]="pickerDateRegister" [min]="min" [max]="max"
               formControlName="dateRegister">
        <mat-datepicker-toggle matSuffix [for]="pickerDateRegister"></mat-datepicker-toggle>
        <mat-datepicker #pickerDateRegister></mat-datepicker>
        <mat-hint align="end">Rango de fechas: {{min | date: 'dd/mm/yyyy'}} - {{max | date: 'dd/mm/yyyy'}}</mat-hint>
      </mat-form-field>
    </ng-template>
    <ng-template [ngIf]="showOrder">
      <mat-form-field appearance="outline">
        <mat-label>Orden</mat-label>
        <input formControlName="orderId" matInput autocomplete="off" placeholder="Ingresar orden..." type="number">
        <mat-hint align="end">Ejemplo: 1,2,3...</mat-hint>
      </mat-form-field>
    </ng-template>
  </ng-template>
  <ng-template [ngIf]="data['modal'].type === 3">
    <mat-form-field appearance="outline">
      <mat-label>Producto</mat-label>
      <input formControlName="product" matInput autocomplete="off" placeholder="Ingresar producto..." type="text">
    </mat-form-field>
    <div class="three-col">
      <mat-form-field appearance="outline">
        <mat-label>Reclamos recibidos</mat-label>
        <input formControlName="received" matInput autocomplete="off" placeholder="Ingresar reclamos recibidos..."
               type="text">
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>Reclamos eliminados</mat-label>
        <input formControlName="delete" matInput autocomplete="off" placeholder="Ingresar Asegurado eliminados..."
               type="text">
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>Porcentaje</mat-label>
        <input formControlName="percent" matInput autocomplete="off" placeholder="Ingresar porcentaje..." type="text">
      </mat-form-field>
    </div>
    <ng-template [ngIf]="showDate">
      <mat-form-field appearance="outline">
        <mat-label>Fecha de registro</mat-label>
        <input id="pickerDateRegister2" matInput [matDatepicker]="pickerDateRegister2" [min]="min" [max]="max"
               formControlName="dateRegister">
        <mat-datepicker-toggle matSuffix [for]="pickerDateRegister2"></mat-datepicker-toggle>
        <mat-datepicker #pickerDateRegister2></mat-datepicker>
        <mat-hint align="end">Rango de fechas: {{min | date: 'dd/mm/yyyy'}} - {{max | date: 'dd/mm/yyyy'}}</mat-hint>
      </mat-form-field>
    </ng-template>
  </ng-template>
  <button (click)="send()" [disabled]="Form.invalid" type="submit" class="vs-btn-blue mt-2">
    {{data && data['id'] ? 'Editar ' : 'Crear '}}
    de {{data['modal'].item}}
  </button>
</form>
